// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileUnknownFilledSvg from "@fishx/icons-svg/es/asn/FileUnknownFilled";
import FishxIcon from '../components/FishxIcon';

var FileUnknownFilled = function FileUnknownFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileUnknownFilledSvg
  }));
};

FileUnknownFilled.displayName = 'FileUnknownFilled';
export default React.forwardRef(FileUnknownFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileUnknownFilled.js
// module id = 2749
// module chunks = 0